import { Minus, Plus } from 'lucide-react'

import { cn } from '../lib/utils'

export interface CountStepperProps {
  value: number
  onChange: (value: number) => void
  /** `+` disables here. */
  max: number
  min?: number
  /** Accessible name for the group, already translated — e.g. "Quick dinners". */
  label: string
  decrementLabel: string
  incrementLabel: string
  className?: string
}

const BUTTON =
  'flex size-[2.625rem] items-center justify-center rounded-full text-foreground transition-colors duration-150 motion-reduce:transition-none enabled:hover:bg-brand-green-tint enabled:hover:text-brand-green-on-tint disabled:cursor-default disabled:text-faint disabled:opacity-55 focus-visible:outline focus-visible:outline-[3px] focus-visible:-outline-offset-2 focus-visible:outline-pelorous-500 dark:focus-visible:outline-pelorous-300'

/** `− n +` in a sunken pill. The number is announced as it changes. */
export function CountStepper({ value, onChange, max, min = 0, label, decrementLabel, incrementLabel, className }: CountStepperProps) {
  return (
    <fieldset
      aria-label={label}
      className={cn('m-0 inline-flex min-w-0 items-center gap-0.5 rounded-full border border-border bg-card-sunken p-px', className)}>
      <button type="button" aria-label={decrementLabel} disabled={value <= min} onClick={() => onChange(value - 1)} className={BUTTON}>
        <Minus className="size-3.5" strokeWidth={2.5} />
      </button>
      <span aria-live="polite" className="min-w-7 text-center font-mono text-base font-medium">
        {value}
      </span>
      <button type="button" aria-label={incrementLabel} disabled={value >= max} onClick={() => onChange(value + 1)} className={BUTTON}>
        <Plus className="size-3.5" strokeWidth={2.5} />
      </button>
    </fieldset>
  )
}
